import styled from 'styled-components'

export const PageWrapper = styled.div`
  background: ${props => props.theme.colors.white};
  padding: 0 0 30px 0;

  .table-wrapper {
    position: relative;
  }

  .table-scroller {
    overflow-x: scroll;
    overflow-y: visible;
    width: calc(100% - 160px);
    margin-left: 130px;
    border-left: 1px solid #eee;
  }

  .submit-button {
    float: right;
    margin: 50px 30px;
  }

  table {
    &.with-fixed {
      th {
        min-width: 130px;
        padding-top: 0px;
      }
    }

    th {
      padding-top: 31px;
      padding-bottom: 10px;
    }

    .fixed {
      left: 0;
      position: absolute;
      top: auto;
      width: 130px;
      height: 48px;
      display: flex;
      align-items: center;
    }

    th:first-child,
    td:first-child {
      padding-left: 50px;
    }

    th:last-child,
    td:last-child {
      padding-right: 35px;
    }

    .cell-input-wrapper {
      position: relative;

      span {
        position: absolute;
      }

      .cost {
        right: 0;
        color: ${props => props.theme.colors.dustyGray};
      }
    }

    .sum-header {
      flex-direction: column;
      align-content: center;
      text-align: left;
      justify-content: center;
      color: ${props => props.theme.colors.primary};

      small {
        display: block;
        text-transform: none;
        font-size: 10px;
      }
    }
    .sum-td {
      text-align: end;
    }
    .cell-input {
      width: 100%;
      background: none;
      border: none;
      padding-left: 15px;
      border-bottom: 1.5px solid ${props => props.theme.colors.secondary};
      outline: none;

      &:focus {
        border-bottom-color: ${props => props.theme.colors.primary};
      }
    }
  }
`
